import React from 'react';
import { NextRouter } from 'next/router';
import { i18nStore } from '../../contexts/i18n';
import { isProductCacheEnabled } from 'utils';

// sets input value as state value
export const handleChange = (
  e: React.ChangeEvent<HTMLInputElement>,
  setSearchText: React.Dispatch<React.SetStateAction<string>>
) => {
  setSearchText(e.target.value);
};

// navigates user to the given location when hitting enter key
export const handleKeyPress = (
  event: React.KeyboardEvent,
  searchText: string,
  router: NextRouter
) => {
  if (event.key === 'Enter') {
    const trimmedValue = searchText.trim();
    if (!trimmedValue) return;
  
    router.push(
      isProductCacheEnabled()
        ? `/searchresults?keyword=${encodeURIComponent(trimmedValue)}`
        : `/search?keyword=${encodeURIComponent(trimmedValue)}`
    );
  }
};

export const onFocusHandler = (
  setShowSearchModal: React.Dispatch<React.SetStateAction<boolean>>
) => {
  setShowSearchModal(true);
};

export const hideSearchResultsModal = (
  setShowSearchModal: React.Dispatch<React.SetStateAction<boolean>>
) => {
  setShowSearchModal(false);
};

// navigates user to the given location when clicking on the element + closes search modal
export const handleOnClick = (
  slug: string | null,
  hideSearchResultsModal: () => void,
  router: NextRouter
) => {
  router.push(`/product/${slug}`);
  hideSearchResultsModal();
};

// filtering the matching results based on name OR sku
// and limiting the results with slice in case of too much matching results
export const getSearchResults = (
  searchText: string,
  data: { data: { sku: string; name: string; slug: string }[] } | undefined
): { sku: string; name: string; slug: string }[] | undefined => {
  const productList = searchText.trim().toLowerCase();
  if (!productList) return [];
  return data?.data
    ?.filter(
      result =>
        result?.name?.toLowerCase().includes(productList) ||
        result?.sku?.toLowerCase().includes(productList)
    )
    .slice(0, 8);
};

export const label = (i18n: i18nStore) => {
  return {
    popular: i18n['Popular Searches'] ?? 'Popular Searches',
    recent: i18n['Recent Searches'] ?? 'Recent Searches',
    suggestion: i18n['Search Suggestions'] ?? 'Search Suggestions',
    noresults: i18n['No Results Found'] ?? 'No Results Found',
    errorOccured:
      i18n['Error while fetching search suggestions'] ??
      'Error while fetching search suggestions',
    placeholder: i18n['Search for products'] ?? 'Search for products',
  };
};
